export const do_nothing_function = () => false;
export const function_return_null = () => null;
export const do_nothing_async = async () => false;
